import React from 'react';
import { 
  Box, 
  IconButton
} from '@mui/material';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MicIcon from '@mui/icons-material/Mic';

const WhatsAppFooter = ({ typingText, isTyping, typingUser = 'contact' }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        bgcolor: '#f0f0f0',
        p: 1,
        borderTop: '1px solid #e0e0e0'
      }}
    >
      <IconButton>
        <EmojiEmotionsIcon />
      </IconButton>
      <IconButton>
        <AttachFileIcon />
      </IconButton>
      
      <Box
        sx={{
          ml: 1,
          mr: 0,
          flex: 1,
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 4,
          bgcolor: 'white',
          border: '1px solid rgba(0, 0, 0, 0.23)',
          display: 'flex',
          alignItems: 'center',
          height: '40px',
          pl: 2,
          pr: 0
        }}
      >
        <Box
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '100%',
            color: '#000',
            fontWeight: 'normal',
            textAlign: 'left',
            direction: typingText && typingText.length > 25 ? 'rtl' : 'ltr',
            textOverflow: 'ellipsis'
          }}
        >
          {/* For long text, show only the last 25 characters */}
          {!typingText ? 'Type a message' : 
            typingText.length > 25 ? 
              typingText.substring(typingText.length - 25) : 
              typingText
          }
        </Box>
      </Box>
      {isTyping && typingUser === 'contact' && (
        <Box 
          sx={{ 
            position: 'absolute', 
            bottom: '60px', 
            left: '20px', 
            bgcolor: 'white',
            color: '#128C7E',
            px: 2,
            py: 0.5,
            borderRadius: 10,
            fontSize: '12px',
            zIndex: 10,
            boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            '& .dot': {
              width: '8px',
              height: '8px',
              margin: '0 1px',
              backgroundColor: '#128C7E',
              borderRadius: '50%',
              display: 'inline-block',
              animation: 'typing-dot 1.4s infinite ease-in-out both',
            },
            '& .dot:nth-of-type(1)': {
              animationDelay: '0s',
            },
            '& .dot:nth-of-type(2)': {
              animationDelay: '0.2s',
            },
            '& .dot:nth-of-type(3)': {
              animationDelay: '0.4s',
            },
            '@keyframes typing-dot': {
              '0%, 80%, 100%': {
                transform: 'scale(0.6)',
                opacity: 0.6,
              },
              '40%': {
                transform: 'scale(1)',
                opacity: 1,
              },
            },
          }}>
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </Box>
        </Box>
      )}
      
      <IconButton sx={{ color: '#128C7E' }}>
        <MicIcon />
      </IconButton>
    </Box>
  );
};

export default WhatsAppFooter;
